import {styled} from '@linaria/react';
import React from 'react';

export const ImageTextsAndCTAWrapper: React.FC<
  React.PropsWithChildren & {
    shouldAddBiggerBottomPadding?: boolean;
    dataTestId: string;
  }
> = ({children, dataTestId, shouldAddBiggerBottomPadding = false}) => {
  return (
    <ImageTextsWrapperContainer
      data-testid={dataTestId}
      shouldAddBiggerBottomPadding={shouldAddBiggerBottomPadding}
    >
      {children}
    </ImageTextsWrapperContainer>
  );
};

const ImageTextsWrapperContainer = styled.div<{
  shouldAddBiggerBottomPadding: boolean;
}>`
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;

  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-end;

  padding-bottom: ${props =>
    props.shouldAddBiggerBottomPadding ? '20px' : '4px'};
`;
